<footer>
    <div class="container mx-0 max-width-wrapper mx-auto">
        <div class="row justify-content-between px-0 mx-0 w-100">
            <!-- 1st container w/SOS logo-->
            <div class="col-12 col-md-2  col-lg-2 px-0">
                <img src="./assets/sos-logo.svg" class="logo">
                <p class="title text-nowrap">Studio on Sunset</p>
            </div>
            <div class="row col-12 col-md-10 col-lg-6 links-wrapper px-0 justify-content-start justify-content-md-center mx-auto">
                <!-- 2nd container  w/ T&C, Privacy Policy, and CP -->
                <div class="px-0 list-group-wrapper">
                    <ul class="list-group">
                        <li class="list-group-item">
                            <a href="#" class="link footer-link">Terms & Conditions</a>
                        </li>
                        <li class="list-group-item">
                            <a href="#" class="link footer-link">Privacy Policy</a>
                        </li>
                        <li class="list-group-item">
                            <a href="#" class="link footer-link">Cookies Policy</a>
                        </li>
                    </ul>
                </div>
                <!-- 3rd container w/disclaimer, EULA, FAQ -->
                <div class="px-0 list-group-wrapper">
                    <ul class="list-group">
                        <li class="list-group-item">
                            <a href="#" class="link footer-link">Disclaimer</a>
                        </li>
                        <li class="list-group-item">
                            <a href="#" class="link footer-link">EULA</a>
                        </li>
                        <li class="list-group-item">
                            <a href="#" class="link footer-link">FAQ</a>
                        </li>
                    </ul>
                </div>
                <!-- 4th container w/ help&support, social media -->
                <div class="px-0 list-group-wrapper">
                    <ul class="list-group">
                        <li class="list-group-item">
                            <a href="#" class="link footer-link">Help & Support</a>
                        </li>
                        <li class="list-group-item">
                            <span><a href="" class="social-media link"><img src="./assets/fb.svg"
                                        class="icon"></a></span>
                            <span><a href="#" class="social-media-link link"><img src="./assets/ig.svg"
                                        class="icon"></a></span>
                            <span><a href="#" class="social-media-link link"><img src="./assets/twitter.svg"
                                        class="icon"></a></span>
                            <span><a href="#" class="social-media-link link"><img src="./assets/pt.svg"></a></span>
                        </li>
                    </ul>
                </div>
            </div>
            <!-- 5th container w/ subscription cta -->
            <div class="col-12 col-md-12 col-lg-4 updates-container">
                <p class="updates">Get updates on new shows</p>
                <div class="input-group mb-3">
                    <input type="text" class="form-control" placeholder="Email" aria-label="Email"
                        aria-describedby="basic-addon2">
                    <button class="input-group-text" id="basic-addon2">Subscribe</button>
                </div>
            </div>
        </div>
    </div>
    <hr />
    <div class="container-fluid px-0 mx-0">
        <div class="row copyright-wrapper mx-auto">
            <div class="col-12 px-0 below-text">
                © 2021 All Rights Reserved
            </div>
        </div>
    </div>
</footer>